
export const apiConstants = {
  url: "/api/eventcategory"
};
